// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__-yKyt","text":"Sidebar_text__XTnAC","logo":"Sidebar_logo__OqNXF"};